import React, { useState, useEffect } from "react";
import {
  gmapServices,
  getSuggestions,
  getPlaceId,
} from "../../../controller/services/gmapServices";
import { Input } from "antd";
import PropTypes from "prop-types";

const GmapAddress = ({ value, onChange, placeholder, id }) => {
  const [listSuggestions, setListSuggestions] = useState([]);
  const [diachi, setDiaChi] = useState("");
  const [selected, setSelected] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);

  useEffect(() => {
    if (value && value.DiaChi) {
      setDiaChi(value.DiaChi);
      setSelected(true);
    }
  }, [value]);

  const handleChgElmt = (evt) => {
    let { value } = evt.target;
    setDiaChi(value);
    setSelected(false);

    if (value && value.trim()) {
      clearTimeout(searchTimeout);
      setSearchTimeout(
        setTimeout(async () => {
          let suggestions = await getSuggestions(value);
          if (!suggestions) {
            setListSuggestions([]);
            return;
          }
          setListSuggestions(suggestions.predictions);
        }, 500),
      );
    } else {
      clearTimeout(searchTimeout);
      setSearchTimeout(
        setTimeout(async () => {
          let evt = { target: { id: id, value: null } };
          onChange(evt);
          setListSuggestions([]);
          setSelected(true);
        }, 500),
      );
    }
  };

  const suggestionsClick = async (item) => {
    setListSuggestions([]);

    let place = await getPlaceId(item.place_id);

    if (!place) {
      setListSuggestions([]);
      return;
    }

    let { result } = place;
    let { formatted_address, geometry } = result;
    let { location } = geometry;
    let evt = {
      target: { id: id, value: { location, DiaChi: formatted_address } },
    };

    onChange(evt);
  };

  let text = selected ? (value && value.DiaChi ? value.DiaChi : "") : diachi;

  return (
    <React.Fragment>
      <span className="col pl-0 pr-0">
        <Input
          type="text"
          onChange={handleChgElmt}
          value={text}
          id={id}
          placeholder={placeholder}
        />
        {!!listSuggestions.length ? (
          <div className="list-gmap-address-suggestions">
            {listSuggestions.map((item, index) => (
              <span
                className="suggestions-item"
                key={index}
                onClick={() => suggestionsClick(item)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    suggestionsClick(item);
                  }
                }}
              >
                *&nbsp;{item.description}
              </span>
            ))}
          </div>
        ) : null}
      </span>
    </React.Fragment>
  );
};

GmapAddress.propTypes = {
  placeholder: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default GmapAddress;
